export default "__VITE_ASSET__R$swVnE3__"